import './styles.scss'
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import CoffeeCommunities from 'Screens/CoffeeWebSocial/Components/CoffeeCommunities'
import PersonalChat from 'Screens/CoffeeWebSocial/Components/PersonalChat'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalLoggedInStatus, getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const CoffeeChats = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const userDetails = getLocalUserDetails()
  const userLoginStatus = getLocalLoggedInStatus()

  const { isChatPanelOpen, setIsChatPanelOpen, personalUnreadCount = 0, communityUnreadCount = 0, onUnreadCountRefresh } = props
  const [activeChatTab, setActiveChatTab] = useState('communities')
  const [selectedCommunityId, setSelectedCommunityId] = useState(null)
  const [selectedUserId, setSelectedUserId] = useState(null)

  const handleChatOpen = () => {
    setIsChatPanelOpen((prev) => !prev)
  }

  const handleNavigation = () => {
    if (activeChatTab === 'communities') {
      history.push(`${ROUTE_STRINGS.coffeeweb}?view=coffee-community&chatTab=communities`)
    } else {
      history.push(`${ROUTE_STRINGS.coffeeweb}?view=coffee-community&chatTab=personalChat`)
    }
  }

  const handlePersonalChatsTabClick = () => {
    if (!userDetails?.id) {
      if (userLoginStatus === false) {
        history.push({ pathname: ROUTE_STRINGS.login })
      } else {
        history.push(ROUTE_STRINGS.createAccount)
      }
    }

    setActiveChatTab('personalChat')
  }

  return (
    isChatPanelOpen && (
      <div className="coffee-quotes-chat-overlay">
        <div className={`coffee-quotes-chat-overlay-panel ${activeChatTab === 'communities' ? 'coffee-quotes-chat-overlay-panel--communities' : ''}`}>
          <div className="coffee-quotes-chat-overlay-header">
            <span className="coffee-quotes-chat-overlay-title">{t('COFFEE_CHAT')}</span>
            <div className="chat-overlay-header-actions">
              <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" className="full-screen-icon" onClick={handleNavigation}>
                <path d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z" />
              </svg>
              <button type="button" className="coffee-quotes-chat-overlay-close" onClick={handleChatOpen}>
                <i className="pi pi-chevron-down" />
              </button>
            </div>
          </div>
          <div className="coffee-quotes-chat-overlay-tabs">
            <button type="button" className={`coffee-quotes-chat-overlay-tab ${activeChatTab === 'communities' ? 'active' : ''}`} onClick={() => setActiveChatTab('communities')} aria-pressed={activeChatTab === 'communities'}>
              {t('COFFEE_COMMUNITIES')}
              {communityUnreadCount > 0 && <span className="chat-tab-badge">{communityUnreadCount > 99 ? '99+' : communityUnreadCount}</span>}
            </button>
            <button type="button" className={`coffee-quotes-chat-overlay-tab ${activeChatTab === 'personalChat' ? 'active' : ''}`} onClick={handlePersonalChatsTabClick} aria-pressed={activeChatTab === 'personalChat'}>
              {t('PERSONAL_CHATS')}
              {personalUnreadCount > 0 && <span className="chat-tab-badge">{personalUnreadCount > 99 ? '99+' : personalUnreadCount}</span>}
            </button>
          </div>
          <div className="coffee-quotes-chat-overlay-content">
            {activeChatTab === 'communities' ? (
              <CoffeeCommunities
                isCoffeePost={true}
                selectedCommunityId={selectedCommunityId}
                onCommunitySelect={setSelectedCommunityId}
                onBackToCommunities={() => setSelectedCommunityId(null)}
                hasHeader={true}
                onUnreadCountRefresh={onUnreadCountRefresh}
                onSwitchToPersonalChat={(userId) => {
                  setActiveChatTab('personalChat')
                  setSelectedUserId(userId || null)
                }}
              />
            ) : (
              <PersonalChat isCoffeePost={true} selectedUserId={selectedUserId} onUnreadCountRefresh={onUnreadCountRefresh} onUserSelect={(uid) => setSelectedUserId(uid || null)} onBackToPersonalChats={() => setSelectedUserId(null)} hasHeader={true} hideSidebar={false} />
            )}
          </div>
        </div>
      </div>
    )
  )
}

export default CoffeeChats
